import { createSlice } from "@reduxjs/toolkit";

interface ScreenState {
  screenName: string;
}

const initialState: ScreenState = {
  screenName: "",
};

const screenNameSlice = createSlice({
  name: "screen",
  initialState,
  reducers: {
    setScreenName(state, action) {
      state.screenName = action.payload;
    },
  },
});

export const screenNameActions = screenNameSlice.actions;

export default screenNameSlice.reducer;
